import { render, staticRenderFns } from "./DeleteConfirmation.vue?vue&type=template&id=4aa506e6&scoped=true&"
import script from "./DeleteConfirmation.vue?vue&type=script&lang=js&"
export * from "./DeleteConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./DeleteConfirmation.vue?vue&type=style&index=0&id=4aa506e6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa506e6",
  null
  
)

export default component.exports